// extracted by mini-css-extract-plugin
module.exports = {"AccountStation":"AccountStation_AccountStation__3HO04","AccountTable":"AccountStation_AccountTable__24n6B"};